import { z } from "zod";

const WebhookDataSchema = z.object({
  runStartedAt: z.string(),
  runFinishedAt: z.string(),
});
export const DbtWebhookRequestBodySchema = z.object({
  eventId: z.string(),
  eventType: z.string(),
  data: WebhookDataSchema,
});
export type DbtWebhookRequestBodyType = z.infer<
  typeof DbtWebhookRequestBodySchema
>;

export const DbtWebhookResponseBodySchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});
export type DbtWebhookResponseBodyType = z.infer<
  typeof DbtWebhookResponseBodySchema
>;
